<template>
  <VListItem
    v-if="appAllowAccess(authenticated, roles, permissions) && ($attrs.debug ? isAppDebugMode : true)"
    v-debug="$attrs.debug ? isAppDebugMode : false"
    v-bind="$attrs"
    :to="cTo"
    :disabled="$attrs.disabled ?? !$attrs.to"
    :color="color"
    :title="title"
  >
    <VListItemAvatar v-if="avatar" size="24">
      <VImg :src="avatar"></VImg>
    </VListItemAvatar>
    <VListItemIcon  v-else>
      <VIcon>{{ icon }}</VIcon>
    </VListItemIcon>
    <VListItemContent>
      <VListItemTitle>
        <div class="d-flex">
          <span class="full-width text-pre-wrap" v-html="title" />
          <span v-if="titleAppend" v-html="titleAppend" />
        </div>
        <div
          v-if="custom"
          v-html="custom"
        />
      </VListItemTitle>
    </VListItemContent>

    <VTooltip bottom>
      <template #activator="{ on, attrs }">
        <VListItemIcon v-if="$attrs.target" v-bind="attrs" v-on="on">
          <VIcon>mdi-open-in-new</VIcon>
        </VListItemIcon>
      </template>
      <span>新しいタブで開く</span>
    </VTooltip>
  </VListItem>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    titleAppend: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'mdi-circle-outline'
    },
    avatar: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: 'primary'
    },
    custom: {
      type: String,
      default: ''
    },
    authenticated: {
      type: Boolean,
      default: false
    },
    roles: {
      type: Array,
      default: () => []
    },
    permissions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    cTo() {
      if (!this.$attrs.to) {
        return null
      }
      if (typeof this.$attrs.to === 'string') {
        return { path: this.$attrs.to, params: { fromSidebar: true } }
      }
      return { ...this.$attrs.to, params: { ...this.$attrs.to.params, fromSidebar: true } }
    }
  }
}
</script>
